{
  "page": {
    "title": "ออเดอร์",
    "customerFallback": "ลูกค้า {{id}}",
    "itemCount_other": "{{count}} รายการ",
    "filterCustomer": "กรองตามลูกค้า: {{id}}",
    "filterConversation": "กรองตามการสนทนา: {{id}}",
    "clearFilter": "ยกเลิกตัวกรอง",
    "retry": "ลองใหม่",
    "empty": "ยังไม่มีออเดอร์",
    "number": "หมายเลข",
    "status": "สถานะ",
    "customer": "ลูกค้า",
    "items": "รายการ",
    "total": "รวม",
    "createdAt": "วันที่สร้าง",
    "previous": "ก่อนหน้า",
    "next": "ถัดไป",
    "pageNumber": "หน้า {{page}}"
  },
  "status": {
    "pendingPayment": "รอชำระเงิน",
    "paid": "ชำระแล้ว",
    "shipped": "จัดส่งแล้ว",
    "cancelled": "ยกเลิก",
    "all": "ทั้งหมด"
  },
  "detail": {
    "notFound": "ไม่พบออเดอร์",
    "backToOrders": "กลับไปหน้าออเดอร์",
    "resent": "ส่งให้ลูกค้าอีกครั้งแล้ว",
    "noChat": "ลูกค้ารายนี้ยังไม่มีแชทสำหรับส่งการ์ด",
    "resendFailed": "ส่งใหม่ไม่สำเร็จ",
    "back": "กลับ",
    "openChat": "เปิดในแชท",
    "resend": "ส่งให้ลูกค้าอีกครั้ง",
    "productItems": "รายการสินค้า",
    "customer": "ลูกค้า",
    "timeline": "กำหนดเวลา",
    "created": "สร้างออเดอร์",
    "paid": "ชำระเงินแล้ว",
    "shipped": "จัดส่งแล้ว",
    "cancelled": "ยกเลิก"
  },
  "create": {
    "title": "สร้างออเดอร์",
    "customer": "ลูกค้า:",
    "loadProductFailed": "ไม่สามารถโหลดสินค้า",
    "addProductFirst": "กรุณาเพิ่มสินค้าก่อน",
    "success": "สร้างออเดอร์เรียบร้อย",
    "failed": "สร้างออเดอร์ไม่สำเร็จ",
    "searchProducts": "ค้นหาสินค้า…",
    "productsEmpty": "ไม่พบสินค้า",
    "previous": "← ก่อนหน้า",
    "next": "ถัดไป →",
    "pageNumber": "หน้า {{page}}",
    "cart": "ตะกร้า",
    "cartEmpty": "ยังไม่มีสินค้า — เลือกจากรายการสินค้าด้านบน",
    "perItem": "{{price}} / ชิ้น",
    "remove": "ลบ",
    "discountBaht": "ส่วนลด (บาท)",
    "shippingBaht": "ค่าส่ง (บาท)",
    "storeShipping": "ค่าส่งตามร้าน",
    "shippingAddress": "ที่อยู่จัดส่ง",
    "recipientName": "ชื่อผู้รับ",
    "phone": "เบอร์โทร",
    "houseNumber": "บ้านเลขที่",
    "soi": "ซอย",
    "road": "ถนน",
    "subDistrict": "แขวง / ตำบล",
    "district": "เขต / อำเภอ",
    "province": "จังหวัด",
    "postalCode": "รหัสไปรษณีย์",
    "subtotal": "รวมก่อนส่วนลด",
    "discount": "ส่วนลด",
    "shipping": "ค่าส่ง",
    "total": "ยอดรวม",
    "skuEmpty": "ยังไม่มี SKU",
    "defaultOption": "ค่าเริ่มต้น",
    "stockRemaining": "{{sku}} · คงเหลือ {{count}}",
    "outOfStock": "หมดสต๊อก",
    "pickCustomer": "เลือกลูกค้า",
    "searchCustomer": "ค้นหาชื่อ, เบอร์โทร หรือ #แท็ก",
    "customerEmpty": "ไม่พบลูกค้า"
  },
  "itemsTable": {
    "product": "สินค้า",
    "price": "ราคา",
    "quantity": "จำนวน",
    "total": "รวม"
  },
  "address": {
    "title": "ที่อยู่จัดส่ง",
    "moo": "หมู่ {{value}}",
    "room": "ห้อง {{value}}",
    "floor": "ชั้น {{value}}",
    "soi": "ซอย {{value}}",
    "road": "ถ.{{value}}"
  },
  "actions": {
    "markPaid": "ทำเครื่องหมายว่าชำระแล้ว",
    "markShipped": "ทำเครื่องหมายว่าจัดส่งแล้ว",
    "cancel": "ยกเลิกออเดอร์",
    "updateFailed": "อัปเดตสถานะไม่สำเร็จ",
    "cancelTitle": "ยกเลิกออเดอร์?",
    "cancelDetail": "ระบบจะคืนสต๊อกอัตโนมัติ ไม่สามารถย้อนกลับได้",
    "confirmCancel": "ยืนยันยกเลิก",
    "no": "ไม่"
  },
  "totals": {
    "subtotal": "ยอดรวมสินค้า",
    "discount": "ส่วนลด",
    "shipping": "ค่าจัดส่ง",
    "net": "ยอดสุทธิ",
    "paymentMethod": "ช่องทางชำระเงิน: {{method}}",
    "promptPay": "พร้อมเพย์",
    "bankTransfer": "โอนผ่านธนาคาร",
    "cash": "เงินสด",
    "other": "อื่น ๆ"
  },
  "errors": {
    "load": "ไม่สามารถโหลดออเดอร์ได้",
    "create": "ไม่สามารถสร้างออเดอร์ได้"
  }
}
